import gql from 'graphql-tag';

export const ANFRAGEN_FRAGMENT = gql`
  fragment engagement on EngagementType {
    id
    firstName
    lastName
    email
    phone
    news
    # organization
    # projectName
    status
    createdAt
    updatedAt
  }
`;
